import { ClusterReportRequest } from '../schemas/clusterReportRequest';
import { ClusterReportResponse } from '../schemas/clusterReportResponse';
import { wranglerSlice } from '../wranglerSlice';

const grapeDataEndpoints = wranglerSlice.injectEndpoints({
  endpoints: (builder) => ({
    getClusterReport: builder.query<
      ClusterReportResponse,
      ClusterReportRequest
    >({
      query: (body: ClusterReportRequest) => ({
        url: '/v1/grape/cluster',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useGetClusterReportQuery } = grapeDataEndpoints;
